// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog_SMgDM {
  background-color : var( --color-white );
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/actions/resetLocation/ResetLocation.css"],"names":[],"mappings":"AAAA;EACE,uCAAuC;EACvC,gBAAgB;AAClB","sourcesContent":[".dialog {\n  background-color : var( --color-white );\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialog": `dialog_SMgDM`
};
export default ___CSS_LOADER_EXPORT___;
